import { Box, Divider, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const PowerBi = () => {
    const iframeRef = useRef(null);
    const { company } = useSelector((state) => state.company);
    const { engagementTotal } = useSelector((state) => state.digitalEngagement);
    const [urls, setUrls] = useState({
        publicUrl: '',
        reportUrl: '',
    });

    const titles = {
        97: 'Digital Engagement Metrics',
        default: 'Digital Physician Engagement Metrics',
    };

    const title = titles[company.id] || titles['default'];

    const adjustIframeHeight = () => {
        const iframe = iframeRef.current;
        if (iframe) {
            try {
                iframe.style.height =
                    iframe.contentWindow.document.body.scrollHeight + 'px';
            } catch (error) {
                console.error('Error adjusting iframe height:', error.message);
            }
        }
    };

    const powerBIUrl =
        'https://app.powerbi.com/view?r=eyJrIjoiNjNhNTA5YTktNjhjNC00NzE5LTk2OWYtOWQxMmU5MWJlNTVmIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9&pageName=ReportSection';

    const POWER_BI_COMPANY_URLS = {
        54: 'https://app.powerbi.com/view?r=eyJrIjoiMjA5ZmFhNGQtNmVjYi00N2MxLWJhY2QtZDkxYjhmYjU5NWRlIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9', // Alunbrig
        16: 'https://app.powerbi.com/view?r=eyJrIjoiMDNiY2UxODktNjFmZC00YjhiLThjNjQtNjEzNGI5YTU1NmRlIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9', // Bavencio
        72: 'https://app.powerbi.com/view?r=eyJrIjoiMjY4MjgxNjMtNmNmZS00NjhmLTk5ZGItMjRkZjQ2YmFkZDNlIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        95: 'https://app.powerbi.com/view?r=eyJrIjoiMWEyMGJlMTItYTU4Ny00NTIwLWJhZDYtMzRkN2Q3YmU1ZThhIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        58: 'https://app.powerbi.com/view?r=eyJrIjoiYzRmODRjYjQtZjQ1NS00MmIzLTkxYmQtY2MxMWI0OGIyODc5IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        42: 'https://app.powerbi.com/view?r=eyJrIjoiMGNkMzNlYjctYzVkYy00ZjQ2LWI2NjItYmIxOTFkZjNkYzhiIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        62: 'https://app.powerbi.com/view?r=eyJrIjoiOGM1YmM1YzctMGFiYy00NTdiLThiMDMtYWY4ZjU4MTE2OGVhIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        67: 'https://app.powerbi.com/view?r=eyJrIjoiMzhjM2Y0OGYtMGEyMy00ZGE5LTkzNzEtYzc0MGJlNmMyY2I1IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        40: 'https://app.powerbi.com/view?r=eyJrIjoiNzU5N2QxYzAtMjliNi00NTFjLTkzZTItNGI1M2I2YzU3NDA4IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        98: 'https://app.powerbi.com/view?r=eyJrIjoiMWM5OGIzYTMtM2E2Zi00ZDBlLWIyM2ItMzQ5NWZjYTRhNDMzIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        97: 'https://app.powerbi.com/view?r=eyJrIjoiMTcxYmIzZDAtNzQ3YS00ZGNjLWE5YzYtMDI4YTMwMWY0OTJlIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        91: 'https://app.powerbi.com/view?r=eyJrIjoiYjAwMTYxMmEtZjhhYi00Njk1LTliZGMtN2RhY2JjNTJjYmVjIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        53: 'https://app.powerbi.com/view?r=eyJrIjoiNzc4MGY4ZTItYmNmNS00ZTc4LWE2ODYtZGEyNWQ5M2RkNTE1IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        38: 'https://app.powerbi.com/view?r=eyJrIjoiNmMxM2FlMDAtNGI0OC00NTEwLWE1ZTQtZWFhNWQyMDUxNGUzIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        96: 'https://app.powerbi.com/view?r=eyJrIjoiNjMzMmQ0NjAtOWZlMi00ZDBjLWI3ZTItYjE1YWQ2Njg0ZWY1IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        92: 'https://app.powerbi.com/view?r=eyJrIjoiMzk5ZjExY2UtMzU5ZS00NjIzLTk5MzQtNjFlZWFiMDIxZTY1IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        59: 'https://app.powerbi.com/view?r=eyJrIjoiMTU4YWRjZmUtMTE4ZS00MWUzLWFkZTgtZWQ3Yjg2ODAzYzRjIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        51: 'https://app.powerbi.com/view?r=eyJrIjoiN2ZjMDQ3MmItM2Q2Ni00NWQzLWExNmItYzIyYWE3YzViYWVlIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        90: 'https://app.powerbi.com/view?r=eyJrIjoiY2FhYmZlZTctMDk4YS00N2QyLTljN2YtMWI3NGZiOTcxZjQ4IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        88: 'https://app.powerbi.com/view?r=eyJrIjoiMmM1NzU0ZWUtYjhmNy00NDM0LTgxNzEtMGJjMmM1ZTAxNjQ3IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        64: 'https://app.powerbi.com/view?r=eyJrIjoiN2U1MjI0NTgtMmUwMC00ZGMzLTljM2UtNGM5MDJhZTljMjRhIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        66: 'https://app.powerbi.com/view?r=eyJrIjoiYWI1ZTU2YTgtOWJiMS00ZmZiLTlhYTctNWQ5OTQ1ZmRkNDY1IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        33: 'https://app.powerbi.com/view?r=eyJrIjoiNWUxMWRjN2MtOWYyNS00MjUyLWI4N2QtNDRiNDMwYmVlNTIxIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        68: 'https://app.powerbi.com/view?r=eyJrIjoiNDAzZDRkYjUtYjExYS00YTJmLTljMjQtYzY2NTZiYzY2NjQ1IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        3: 'https://app.powerbi.com/view?r=eyJrIjoiNjhiMGNhMDYtOTYxOS00OTdkLWFmYzQtYjdlMGMwYjA0MTVmIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        81: 'https://app.powerbi.com/view?r=eyJrIjoiMTE2ZDNmZmItMTE2MC00MjNmLThmZDMtMTM2NzE5NDc4ZWRjIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        45: 'https://app.powerbi.com/view?r=eyJrIjoiNWJkMzRlOGMtM2Q1NC00Y2IwLTgyZWMtNWUwOTNjN2M4NmY3IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        94: 'https://app.powerbi.com/view?r=eyJrIjoiM2ZjYjNmYmEtNzlhZC00NjBmLWEyNWYtZjU1MTU2NjE4NDE1IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        99: 'https://app.powerbi.com/view?r=eyJrIjoiZjI3MGZjZDAtNmRkMy00NDc1LWFmNGUtY2Y4MzkzMGM2ZWUzIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        102: 'https://app.powerbi.com/view?r=eyJrIjoiMzdiZWYxNGItZGQ5My00N2EzLThkOTAtNDc5YjNmMDI3MzNiIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        103: 'https://app.powerbi.com/view?r=eyJrIjoiMzRkZWNmY2EtYjcxYy00YTExLWI4OTQtOGNmNjU5YzNlZjVhIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        104: 'https://app.powerbi.com/view?r=eyJrIjoiYTYyZjcwYzgtZmIyNC00ZWE1LTlhM2UtNDBiN2VkNTM4YjJhIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        106: 'https://app.powerbi.com/view?r=eyJrIjoiODlhMjlkZTItZTk3ZS00MzExLTk3MjUtMDQ0YjlmNzVjMTY0IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        107: 'https://app.powerbi.com/view?r=eyJrIjoiZjYzMWMzMTItNTA4OS00MDU3LTg4NDktNDUzYjk2YTdmYmYyIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        108: 'https://app.powerbi.com/view?r=eyJrIjoiNmI0MWE5YzUtNDcxZi00NjkwLWExMjMtMWRlZDM0YmMzMjcwIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        109: 'https://app.powerbi.com/view?r=eyJrIjoiYzdlZTIyYWYtOTNjMy00NjllLThjMjYtZjk0NmQ4ZWMyYTk1IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        110: 'https://app.powerbi.com/view?r=eyJrIjoiNmZlMTJjNDUtYjc5MC00MThmLTgzYmEtZDgzZjE4ZmFiNWYwIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        111: 'https://app.powerbi.com/view?r=eyJrIjoiNDBjYzMxYzEtNTgwMy00NmNhLWIyZjItYjJhNTI1N2E4NDAxIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        112: 'https://app.powerbi.com/view?r=eyJrIjoiZWQ4MGJkNmUtM2U0ZS00ZDZiLWE2YjEtYTllNTFiOTYyYmMwIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
        113: 'https://app.powerbi.com/view?r=eyJrIjoiNWU5ODIxZDgtNDFkZS00NmExLWFhOWUtZTcyMTFmYjdjYjM5IiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9',
    };
    const handlePowerBILinks = () => {
        const defaultUrl =
            'https://app.powerbi.com/view?r=eyJrIjoiODlmOThmMWItNzJkNy00Mjc5LWJkNjctY2RjMWNiMDZiY2MzIiwidCI6IjQxMGYxMWYwLTUzYjgtNDAzNi1hZTdkLWI1ZDkwYmVkY2MzMiIsImMiOjN9';

        const selectedUrl = POWER_BI_COMPANY_URLS[company.id] || defaultUrl;

        setUrls({
            publicUrl: selectedUrl,
            reportUrl: selectedUrl,
        });
    };

    useEffect(() => {
        if (company.id) {
            handlePowerBILinks();
        }
    }, [company.id]);

    return (
        <>
            {engagementTotal > 0 && (
                <Box>
                    <Divider className="mv-24 border-1-gray" />
                    <Box>
                        <Typography className="text-center text-lg-semi-bold gray-900">
                            {title}
                        </Typography>
                    </Box>
                    <Box
                        className={'bg-white border-softer mt-5 mb-5'}
                        sx={{ height: '100vh' }}
                    >
                        {powerBIUrl !== urls?.publicUrl ? (
                            <iframe
                                allowFullScreen="true"
                                ref={iframeRef}
                                src={urls?.reportUrl}
                                style={{
                                    height: '100vh',
                                    width: '100%',
                                    border: 'none',
                                }}
                                title=""
                                onLoad={adjustIframeHeight}
                            />
                        ) : (
                            <iframe
                                allowFullScreen="true"
                                ref={iframeRef}
                                src={urls?.publicUrl}
                                style={{
                                    height: '100vh',
                                    width: '100%',
                                    border: 'none',
                                }}
                                title=""
                                onLoad={adjustIframeHeight}
                            />
                        )}
                    </Box>
                </Box>
            )}
        </>
    );
};

export default PowerBi;
